import { Plus } from "lucide-react";
import { PageHero, Container, SectionHead, CTASection } from "@/components/common/Section";
import { Reveal } from "@/lib/anim";
import { SOLUTION_GROUPS } from "@/lib/content";

const INTEGRATION_GROUP = {
  num: "05",
  title: "Integration",
  items: [
    "Integration architecture",
    "Connector development",
    "Third-party system integration",
    "Bank & payment provider connectivity",
    "Legacy integration modernization",
  ],
};

export default function Solutions() {
  const groups = [...SOLUTION_GROUPS, INTEGRATION_GROUP];
  return (
    <>
      <PageHero
        eyebrow="Solutions"
        title="From payment strategy to production."
        copy="iJeeva's capabilities are organized around financial technology: payment engineering, banking infrastructure, product engineering, modernization and integration."
        testid="solutions-page-title"
      />
      <section id="services" className="scroll-mt-24 py-20 lg:py-24">
        <Container>
          <SectionHead
            eyebrow="Capabilities"
            title="What we build."
            copy="Every engagement draws on deep payments domain knowledge and hands-on platform engineering."
          />
          <div className="mt-14">
            {groups.map((g, gi) => (
              <Reveal
                key={g.num}
                delay={gi * 40}
                className={`grid gap-6 border-t border-[#E2E8F0] py-10 md:grid-cols-12 ${
                  gi === groups.length - 1 ? "border-b" : ""
                }`}
              >
                <div className="md:col-span-4">
                  <h3 className="text-xl font-semibold text-[#1D305B] sm:text-2xl">{g.title}</h3>
                </div>
                <ul className="grid gap-x-10 gap-y-3 sm:grid-cols-2 md:col-span-8">
                  {g.items.map((item) => (
                    <li key={item} className="flex items-center gap-2.5 text-[15px] text-[#475569]">
                      <Plus className="h-3.5 w-3.5 shrink-0 text-[#0EA5A4]" strokeWidth={2.5} aria-hidden="true" />
                      {item}
                    </li>
                  ))}
                </ul>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>
      <CTASection
        title="Have a payments problem to solve?"
        copy="From a single integration to a full platform build, and let's scope it together."
      />
    </>
  );
}
